// Projekter tilføjes løbende — et ad gangen med billeder, tekst og Facebook-link.
// Hvert projekt har en primær cover `image` + valgfri `images[]` til galleri + `longDescription` til dialog.

export const projectCategories = [
    { id: "alle", label: "Alle projekter" },
    { id: "terrasser", label: "Terrasser & Uderum" },
    { id: "renovering", label: "Renovering" },
    { id: "carporte", label: "Carporte & Skure" },
];

export const projects = [
    {
        id: "sommerhusterrasse-80m2",
        title: "80+ m² sommerhusterrasse",
        category: "terrasser",
        categoryLabel: "Terrasser & Uderum",
        location: "Sommerhus",
        year: "2025",
        description:
            "Over 80 m² trykimprægneret terrasse ved et sommerhus — solid, holdbar og klar til mange års hygge.",
        longDescription:
            "NY TERRASSE!!\n80+ m² sommerhushygge ☀️\n\nVi har netop færdiggjort denne store terrasse i trykimprægnerede terrassebrædder ved et sommerhus – over 80 kvadratmeter terrasse, klar til at blive nydt mange år frem!\n\nKunden ønskede en solid, holdbar løsning med god plads til både familie og gæster, og resultatet taler for sig selv. Tak for tilliden!\n\nFagligt håndværk du kan stole på 🔨",
        image: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/6thlpexs_589144604_122093649981146607_2415251342467445968_n.jpg",
        images: [
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/41n6b515_587532786_122093649915146607_7199265401602426814_n.jpg",
                caption: "Før — pladsen ryddet og klargjort",
            },
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/8ltpt38g_587039005_122093649675146607_5578585131050366148_n.jpg",
                caption: "Under — strøer og stolper lagt ud med fast hånd",
            },
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/6thlpexs_589144604_122093649981146607_2415251342467445968_n.jpg",
                caption: "Efter — færdig 80+ m² terrasse klar til brug",
            },
        ],
        facebookUrl: "https://www.facebook.com/nstomrer",
    },
    {
        id: "entre-bryggers-totalrenovering",
        title: "Totalrenovering af entré & bryggers",
        category: "renovering",
        categoryLabel: "Renovering",
        location: "Privatkunde",
        year: "2025",
        description:
            "Gennemgribende totalrenovering — fra blåmalede mure og gammel skorsten til et lyst, moderne og velisoleret entré/bryggers.",
        longDescription:
            "TOTALRENOVERING AF ENTRÉ & BRYGGERS 🔨✨\n\nVi hos NS Tømrer & Ejendomsservice har netop afsluttet en gennemgribende totalrenovering af et entré/bryggers for en kunde – og det er blevet et kæmpe løft!\n\nOpgaven omfattede bl.a.:\n✔ Nedrivning af gammel skorsten\n✔ Ny isolering i loftet\n✔ Montering af nye Troldtekt-plader\n✔ Nye forsatsvægge\n✔ Nye energivenlige vinduer\n✔ Nyt gulv\n✔ Installation af enkelte bryggers-møbelløsning (genbrugs­møbler og bordplade)\n\nRummet er blevet langt lysere, mere funktionelt og langt bedre isoleret – og kunden har fået en moderne, praktisk entré/bryggers med et flot finish og stor holdbarhed.\n\nStort tak for opgaven.\n\nKvalitet fra start til slut 💪",
        image: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/yz910zas_587659835_122093653401146607_6310801390099607258_n.jpg",
        images: [
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/ecy5vfkj_587492705_122093653371146607_1860689194560258471_n.jpg",
                caption: "Før — gammel skorsten og blåmalede mure",
            },
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/mi5edt5g_588535779_122093653383146607_8707333064121856403_n.jpg",
                caption: "Under — gulvene er brækket op, klar til ny opbygning",
            },
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/yz910zas_587659835_122093653401146607_6310801390099607258_n.jpg",
                caption:
                    "Efter — lyst, moderne entré/bryggers med nye vinduer, gulv og møbler",
            },
        ],
        facebookUrl: "https://www.facebook.com/nstomrer",
    },
    {
        id: "carport-med-skur-silkeborg",
        title: "Ny carport med skur",
        category: "carporte",
        categoryLabel: "Carporte & Skure",
        location: "Silkeborg",
        year: "2025",
        description:
            "Solid, fladtagscarport med integreret skur — bygget fra fundament til færdigt finish. Perfekt løsning til både bil og opbevaring.",
        longDescription:
            "Ny carport med skur færdigbygget i Silkeborg! 🚗🏡\n\nEndnu et projekt er afsluttet – denne gang en helt ny, solid carport med integreret skur, bygget af NS Tømrer og Ejendomsservice.\n\nPerfekt løsning til både opbevaring og beskyttelse af bilen. Kunden er super tilfreds med resultatet, og jeg er klar til at hjælpe flere kunder med lignende opgaver – store som små.\n\nHar du brug for en ny carport, et skur eller noget helt andet? Så står jeg klar til at hjælpe!\n\n📩 Kontakt mig:\nNicklas Sørensen\n📞 29 88 04 52\n📧 nstomrer@gmail.com",
        image: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/kygerpls_597852311_122104904877146607_2859110013903591007_n.jpg",
        images: [
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/x4b68bms_599582499_122104904685146607_226349954288970113_n.jpg",
                caption: "Før — materialer leveret, sne over byggepladsen",
            },
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/vpz4vc3v_597866987_122104904787146607_9223066971091923109_n.jpg",
                caption:
                    "Under — konstruktionen rejst: stolper, bjælker og tagramme på plads",
            },
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/kygerpls_597852311_122104904877146607_2859110013903591007_n.jpg",
                caption:
                    "Efter — færdig carport med integreret skur og flot lodret beklædning",
            },
        ],
        facebookUrl: "https://www.facebook.com/nstomrer",
    },
    {
        id: "loftsrenovering-silkeborg",
        title: "Loftsrenovering",
        category: "renovering",
        categoryLabel: "Renovering",
        location: "Silkeborg",
        year: "2025 · Igangværende",
        status: "in-progress",
        description:
            "Igangværende loftsrenovering med ny dampspærre, forskalling og gipsloft — udført efter gældende krav til tæthed og isolering.",
        longDescription:
            "🔨 Nyt projekt i Silkeborg 🔨\n\nHos NS Tømrer og Ejendomsservice er vi netop startet op på et spændende projekt i Silkeborg, hvor vi skal udføre en loftsrenovering.\n\nOpgaven består blandt andet af:\n✔️ Montering af ny dampspærre\n✔️ Ny forskalling\n✔️ Opsætning af nyt gipsloft\n\nDet gamle loft er taget ned, og vi er nu i gang med at klargøre konstruktionen, så alt bliver udført korrekt og lever op til de gældende krav til tæthed og isolering.\n\nVi glæder os til at vise mere fra processen, når projektet skrider frem. 👷‍♂️\n\nHar du også et projekt, du skal have lavet, er du altid velkommen til at kontakte os.\n📞 Tlf: 29 88 04 52\n📧 Mail: nstomrer@gmail.com",
        image: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/f7o3zzsq_649326065_122119201041146607_2842394423910343379_n.jpg",
        images: [
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/45xbd72f_649509473_122119201023146607_8746944214180891690_n.jpg",
                caption: "Adressen — NS-skilt sat op, klar til at gå i gang",
            },
            {
                url: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/f7o3zzsq_649326065_122119201041146607_2842394423910343379_n.jpg",
                caption:
                    "Under — ny dampspærre og forskalling monteret, klar til gipsloft",
            },
        ],
        facebookUrl: "https://www.facebook.com/nstomrer",
    },
];
